import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { PeopleExplorerBackgroundContainer, Profile } from './PeopleExplorerBackground.styles';
import usePeopleProfileBackground from './usePeopleProfileBackground';

interface PeopleExplorerBackgroundProps {
  mobile?: boolean;
}

const PeopleExplorerBackground = ({ mobile }: PeopleExplorerBackgroundProps): JSX.Element => {
  const profileImages = usePeopleProfileBackground(mobile);

  return (
    <PeopleExplorerBackgroundContainer>
      {profileImages.map((face, index) => {
        return (
          <Profile
            delay={index * 0.3}
            key={index}
            fixed={mobile}
            style={{
              ...face.position,
              width: `${face.size}px`,
              height: `${face.size}px`,
            }}
          >
            <GatsbyImage
              image={face.image}
              loading='eager'
              alt={`profile-picture-${index}`}
            />
          </Profile>
        );
      })}
    </PeopleExplorerBackgroundContainer>
  );
};

export default PeopleExplorerBackground;
